import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import RichText from './rich-text';
import { useGlobalLayout } from '$contexts/global-layout';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const HeaderDrawer = ({
    headerOpen,
    links
}) => {
    const { formatURI } = useLocale();

    const dialogRef = useRef();

    const { setHeaderOpen } = useGlobalLayout();
    const close = () => {
        setHeaderOpen(false);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') { close(); }
        };

        window.addEventListener('keydown', handleKeyDown, { passive: true });

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    const getUrlSegment = (typename, item) => {
        let urlSegment;
        if (typename === 'BvaBusinessResourcePage') {
            urlSegment = 'resources';
        } else if (typename === 'BvaBusinessCaseStudyPage') {
            urlSegment = 'case-studies';
        } else if (typename === 'BvaBusinessLandingSubPage') {
            urlSegment = item?.parent?.bvaBusinessLandingPageCollection?.items?.[0]?.slug;
        }

        return urlSegment;
    };

    return (
        <>
            <div
                className={`${headerOpen ? 'bg-sand h-auto relative layout-container pb-50 hidden md:block' : 'hidden'}`}
                inert={headerOpen ? null : ''}
                ref={dialogRef}>
                <div className='w-full md:mt-90'>

                    {links && (
                        <div
                            className='flex flex-wrap flex-row gap-y-20'>
                            {links?.map((link, idx) => {
                                const headerLinkUrl = formatURI(link?.headerLink?.slug);
                                return (
                                    <div
                                        className='md:px-10 md:w-4/12'
                                        key={idx}>
                                        <div
                                            className='flex flex-col'>
                                            {(link?.headerLink) && (
                                                <a
                                                    className={`type-style-3 ${link?.subLinkSize === 'Small' ? 'md:mb-15' : 'md:mb-20'}`}
                                                    href={headerLinkUrl}>
                                                    {link?.headerLink?.title}
                                                </a>
                                            )}
                                            {link?.subLinksCollection?.items?.length > 0 && (
                                                link?.subLinksCollection?.items?.map((sublink, i) => {

                                                    if (sublink?.body) {
                                                        return (
                                                            <RichText
                                                                className={`${link?.subLinkSize === 'Small' ? 'type-style-7' : 'type-style-3'} md:mb-20`}
                                                                key={i}
                                                                {...sublink?.body} />
                                                        );
                                                    } else {
                                                        if (sublink?.__typename === 'BvaBusinessResourceListingPage' || sublink?.__typename === 'BvaBusinessCaseStudyListingPage') {
                                                            return (
                                                                <a
                                                                    className={`${link?.subLinkSize === 'Small' ? 'type-style-7' : 'type-style-3'} md:mb-20`}
                                                                    href={`/${formatURI(sublink?.slug)}`}
                                                                    key={i}>
                                                                    {sublink?.title}
                                                                </a>
                                                            );
                                                        } else {
                                                            const segment = getUrlSegment(sublink?.__typename, sublink);
                                                            const slug = sublink?.slug;
                                                            const sublinkUrl = formatURI(`${segment}/${slug}`);

                                                            // TODO: find out why parent page segment is undefined.
                                                            return (
                                                                <a
                                                                    className={`${link?.subLinkSize === 'Small' ? 'type-style-7' : 'type-style-3'} md:mb-20`}
                                                                    href={sublinkUrl}
                                                                    // href={`/${getUrlSegment(sublink?.__typename, sublink)}/${sublink?.slug}`}
                                                                    key={i}>
                                                                    {sublink?.title}
                                                                </a>
                                                            );
                                                        }
                                                    }
                                                })
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    headerOpen: PropTypes.bool,
    links: PropTypes.array,
};

HeaderDrawer.propTypes = propTypes;

export default HeaderDrawer;
